import { useState } from 'react';
import InfoComponent from '../InfoComponent';
import IpInput from '../IpInput';
import validator from 'validator';
import Card from '../../common/card/Card';
import HeadingServices from '../../services/HeadingServices';
import Loading from '../../svg/Loading';
import { useRouter } from 'next/router';
import axios from 'axios'

export default function ReverseHosting({ datasReverse }) {

    const router  = useRouter()
    const language = router.locale === 'tr' ? "Turkish": "English" 
    const [dataReverse, setDataReverse] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [ips, setIps] = useState("");

    const [infoMessage, setInfoMessage] = useState('')

    const [dataReverseMessage, setDataReverseMessage] = useState('');
    
    const [ip, setIp] = useState('');
    const [ipHeader, setIpHeader] = useState('');
    const [isValid, setIsValid] = useState(false);
    const [error, setError] = useState();

    const loadData = async (ipData) => {
        try {
            setLoading(true);
            const res = await fetch(`${process.env.isApiserver}/rip/1`,
                {
                    body: JSON.stringify({ query: ipData.trim() }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    method: 'POST'
                })
            const data = await res.json();
            if (data.retcode === -20) {
                setDataReverseMessage(data.message);
                setDataReverse([])
                setIps("")
            }
            if (data.retcode === -50) {
                setDataReverseMessage(datasReverse.messMissing);
                setDataReverse([])
                setIps("")
            }
            if (data.retcode === 201) {
                setDataReverseMessage("");
                setInfoMessage(datasReverse.messNoFound)
                setDataReverse([])
                setIps(data.ip4)
            }
            if (data.retcode === 200) {
                setDataReverseMessage("");
                setInfoMessage(datasReverse.infoMessage)
                setDataReverse(data.data)
                setIps(data.ip4)
            }
            setLoading(false);

        } catch (err) {
            setLoading(false);
        }

    }

    const clearHandle = () => {
        setIp('');
        setDataReverse([]);
        setInfoMessage('')
    }


    const onChangeHandler = (event) => {

        let isValid = true;
        let ipValid = false;
        const dataEvent = event.target.value;
        let numberRegex = /^[0-9]+$/;
        let numb = numberRegex.test(dataEvent);

        if (numb) ipValid = validator.isIP(dataEvent, [4]);
        else ipValid = validator.isURL(dataEvent, [{ require_protocol: false }])

        if (!ipValid) {
            isValid = false;
            setError(language === "Turkish" ? "Lutfen IP veya Hostname dogru giriniz" : "Please enter correct Ip or Hostname");
        }
        if (dataEvent.trim().length === 0) {
            isValid = false;
            setError(language === "Turkish" ? "Bu alan boş bırakılamaz." : "This field cannot be left blank");
        }
        if (ipValid) setError("")
        setIp(dataEvent);
        setIsValid(isValid);
    }


    const onSubmitHandler = async (event) => {
        event.preventDefault();
        await loadData(ip);
        setIpHeader(ip)
        setIp('');
    }


    return (
        <>
            <HeadingServices 
                title={datasReverse.upperTitle} 
                lowerTitle={datasReverse.title} />
            <div className="container section mb-5 mt-3">
                <InfoComponent info={datasReverse.info} />
                {isLoading && <div className="text-center"><Loading /></div>}
                {!isLoading && <IpInput
                    title={datasReverse.lookupTitle}
                    value={ip}
                    placeHolder={datasReverse.placeHolder}
                    error={error}
                    isValid={isValid}
                    buttonSearch={datasReverse.buttonSearch}
                    buttonClear={datasReverse.buttonClear}
                    onSubmitHandler={onSubmitHandler}
                    onChangeHandler={onChangeHandler}
                    clearHandle={clearHandle}
                    message={dataReverseMessage}
                />}
                {(dataReverse.length > 0 || infoMessage) && dataReverseMessage === "" && !isLoading &&
                    <Card
                    ip={ipHeader}
                    maximumLengthMessage={datasReverse.maximumLengthMessage}
                        ips={ips}
                        length={dataReverse.length}
                        items={dataReverse.slice(0, 100)}
                        title={datasReverse.lookupTitle}
                        info={infoMessage}
                        resultCountMessage={datasReverse.resultCountMessage} />
                }
            </div>
        </>
    )
}


